/* eslint-disable react/jsx-pascal-case */
import { Route, HashRouter as Router, Routes } from "react-router-dom";
import About_FMS from "./2.FMS/About_FMS";
import Home_FMS from "./2.FMS/Home_FMS";
import Info_FMS from "./2.FMS/Info_FMS";
import Platform_FMS from "./2.FMS/Platform_FMS";
import Process_FMS from "./2.FMS/Process_FMS";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home_FMS />} />
        <Route path="/about" element={<About_FMS />} />
        <Route path="/Platform" element={<Platform_FMS />} />
        <Route path="/Info" element={<Info_FMS />} />
        <Route path="/Process_FMS" element={<Process_FMS />} />

        {/* 여기에 추가 라우트를 정의할 수 있습니다. */}
      </Routes>
    </Router>
  );
}

export default App;
